export enum BandSignupStep {
  SelectAgencyKind,
  CreateAgency,
  CreateBand,
  SetSocialMedia,
  SelectSubgenres,
  UploadPicture,
  SelectTrackReleaseStatus,
}
